// Apply the theme

Highcharts.theme = {
    colors: [
        '#f39114', '#fdc938', '#4572a7', '#80699b', '#84db0e', '#bf362e',
        '#4bcdcf', '#999999', '#a47d7c', '#92a8cd', '#b5ca92'
    ]
};
Highcharts.setOptions(Highcharts.theme);

var exportingOptions = Highcharts.getOptions().exporting;
exportingOptions.buttons.contextButton.menuItems = [{text: 'Download PNG image', onclick: (function() {this.exportChart()})}];

Highcharts.setOptions({exporting: exportingOptions});

Highcharts.setOptions({credits: {enabled: false}});

//Highcharts habia agregado sombras en los labels como default. Esto lo revierte
var graphTypes = ['area','arearange','areaspline','areasplinerange','bar','bubble','column','columnrange','funnel','gauge','heatmap','line','pie','polygon','pyramid','scatter','series','solidgauge','spline','treemap','waterfall'];
var plotOptions = {};
graphTypes.forEach(function(graphType){
  (((plotOptions[graphType] = {}).dataLabels = {}).style = {}).textShadow = false;
});
Highcharts.setOptions({plotOptions: plotOptions});
